import cn from 'clsx'

import { Copy, NavLink } from 'shared-components'

import Phone from '../../../images/phone'
import Email from '../../../images/email'
import Address from '../../../images/address'

import s from './Locations.module.sass'

function Locations({ locations }: any) {
    if (!locations) return null

    return (
        <div className={s.Locations}>
            {locations.map((location: any, index: number) => {
                const { name, phone, email, additionalEmail, address } = location

                return (
                    <div className={s.Location} key={index}>
                        {name && <div className={s.Title} dangerouslySetInnerHTML={{ __html: name }} />}
                        {phone && (
                            <div className={cn(s.Phone, 'copy small')}>
                                <span>{Phone}</span>
                                <div className={s.Copy}>
                                    <NavLink href={`tel:${phone}`} className={s.Link}>
                                        {phone}
                                    </NavLink>
                                </div>
                            </div>
                        )}
                        {email && (
                            <div className={cn(s.Email, 'copy small')}>
                                <span>{Email}</span>
                                <div className={s.Copy}>
                                    <NavLink href={`mailto:${email}`} className={s.Link}>
                                        {email}
                                    </NavLink>
                                    {additionalEmail && (
                                        <>
                                            <br />
                                            <NavLink href={`mailto:${additionalEmail}`} className={s.Link}>
                                                {additionalEmail}
                                            </NavLink>
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                        {address && (
                            <div className={cn(s.Address, 'copy small')}>
                                <span>{Address}</span>
                                <div className={s.Copy}>
                                    <Copy copy={address} size="small" />
                                </div>
                            </div>
                        )}
                    </div>
                )
            })}
        </div>
    )
}

export default Locations
